"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.regexPhone = void 0;
exports.isValidPhoneNumber = isValidPhoneNumber;
exports.regexPhone = new RegExp(/^(?:\+?[0-9\s\-()]{2,}|)$/);
function isValidPhoneNumber(phoneNumber) {
    return exports.regexPhone.test(phoneNumber);
}
